import { StrictMode } from "react";

import { createRoot } from "react-dom/client";

import App from "./App.tsx";
import { configureAxiosBaseUrl } from "./config/network.ts";
import "./components/layouts/global.css";

import { interceptor } from "./tools/interceptor.ts";
import { initPostHog } from "./tools/posthog.ts";
import "./config/style/global.css";

initPostHog();
configureAxiosBaseUrl();
interceptor();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
